//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/Object.js";
import "../Features/Features.FeatureCollection.js";
let d=[[],[[["offset3DCurve"],"CreateOffset3dCurveBuilder",{R_:{builder:"Features.Offset3DCurveBuilder"}},1,0],[["scaleCurve"],"CreateScaleCurveBuilder",{R_:{builder:"Features.ScaleCurveBuilder"}},1,0],[["shadow_curve"],"CreateShadowCurveBuilder",{R_:{builder:"Features.ShadowCurveBuilder"}},1,0],[["spun_outline"],"CreateRevolveOutlineBuilder",{R_:{builder:"Features.RevolveOutlineBuilder"}},1,0]],[]];
SPLM.Features.CurveFeatureCollection = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Features.CurveFeatureCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;